import CategoryTabs from '../category-tabs';
import SearchBar from '../search-bar';

const Sidebar = ({ activeCategory, onSelectCategory, onSearch, tab, categories }) => {
	return (
		<aside className="vayu-sidebar">
			<SearchBar onSearch={onSearch} activeTab={tab} />
			<div className="vayu-category-tabs-wrapper">
				<CategoryTabs
					activeCategory={activeCategory}
					onSelect={onSelectCategory}
					tab={tab}
					categories={categories}
				/>
			</div>
		</aside>
	);
};

export default Sidebar;
